import { BakeShadows } from '@react-three/drei';
import { useEffect, useRef, useMemo } from 'react';
import { Vector3, DirectionalLight } from 'three';

interface LightsProps {
  greenPos?: Vector3 | null | undefined;
}

const Lights: React.FC<LightsProps> = ({ greenPos }) => {
  const lightRef = useRef<DirectionalLight>(null);

  const lightPosition = useMemo(() => {
    if (!greenPos || !greenPos.x || !greenPos.y || !greenPos.z) return null;
    return new Vector3(greenPos.x, greenPos.y + 200, greenPos.z);
  }, [greenPos]);

  useEffect(() => {
    if (!lightRef.current || !lightPosition) return;
    lightRef.current.position.copy(lightPosition);
  }, [lightPosition]);

  return (
    <>
      <directionalLight
        ref={lightRef}
        castShadow
        intensity={0.5}
        shadow-mapSize={[4096, 4096]}
        shadow-camera-near={1}
        shadow-camera-far={2000}
        shadow-camera-left={-50}
        shadow-camera-right={50}
        shadow-camera-top={50}
        shadow-camera-bottom={-50}
      />
      <BakeShadows />
      <ambientLight intensity={3} />
      <color attach="background" args={['#f2f3f4']} />
    </>
  );
};

export default Lights;
